module.exports = __webpack_public_path__ + "img/7.bcab7b9d.png";